import Surface from '@cube3/cubicle/src/components/Surface/Surface';
import { Button } from '@cube3/cubicle/src/core/atoms/Button/Button';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import Time from '@cube3/cubicle/src/core/utility/Time';
import React, { useCallback, useState } from 'react';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { usePrivilegesRoot } from '@cube3/state/src/redux/components/Hooks/usePermission';
import {
  TRIAL_PLAN_NAME,
  useTrialWorkspaceCheck
} from '../components/app/layout/AdminCenter/hooks/useTrialWorkspaceCheck';

export const TrialCountDownBanner = () => {
  const [show, setShow] = useState(true);
  const privileges = usePrivilegesRoot();

  const isAdmin = privileges && privileges.includes('WORKSPACE_WRITE');

  const { expireAt, hasExpired, plan, haSubscription, onClickUpgrade } =
    useTrialWorkspaceCheck();

  const onClose = useCallback(() => setShow(false), [setShow]);

  const isCanceled = haSubscription && expireAt && plan !== TRIAL_PLAN_NAME;

  return (
    expireAt &&
    show && (
      <Surface background="base2" gradient={'lamp'} floating={true}>
        <HBox
          align="center"
          justify="center"
          gap={16}
          style={{
            padding: '8px',
            position: 'relative'
          }}
        >
          {hasExpired ? (
            <Typography colorVariant="02" color={'warning'}>
              The workspace is read-only until upgraded.
            </Typography>
          ) : (
            <Typography colorVariant="02" color={'default'}>
              {isCanceled ? 'Subscription cancelled. ' : ''}
              Uploads, links and new projects will get locked{' '}
              <Time
                date={expireAt}
                fullForm={false}
                toolTip={false}
                placement="bottom"
                relativeTime={true}
              />
              {' - '}upgrade now:
            </Typography>
          )}
          {isAdmin && (
            <Button
              label={isCanceled ? "Renew" : "Upgrade"}
              buttonStyle="solid"
              background="primary"
              onClick={onClickUpgrade}
            />
          )}
        </HBox>
        {!hasExpired && (
          <span
            style={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)'
            }}
          >
            <Button iconLeft="close" buttonStyle="ghost" onClick={onClose} />
          </span>
        )}
      </Surface>
    )
  );
};
